import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;


@Injectable()
export class WelcomeService {
  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  handleError = (error) => {
    return throwError(error);
  }

  getWelcomeDetails() {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return this.httpClientService.get(this.utilityService.getEnvConfig().WelcomeUrl, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (res.headers.get('Authorization') != null) {
          sessionStorage.setItem('sapmp_jwtToken', res.headers.get('Authorization'));
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }


  tokenRefresh() {
    this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
  }

  getInitialSignupDetails(signup) {
    let headers = this.get_headers();
    if (signup === true) {
      headers = headers.append('signUp', signup);
      if (sessionStorage.getItem('eligibleFanList')) {
        headers = headers.append('eligibleFanList', sessionStorage.getItem('eligibleFanList'));
      }
    }
    return this.httpClientService.get(this.utilityService.getEnvConfig().WelcomeSignupUrl, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          // sessionStorage.setItem('jwtToken', res.headers.get('SERVICE-AUTH-TOKEN'));
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  requestPopupContent(id) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return this.httpClientService.get(id, headers)
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  createPageLoadProperties(url) {
    const dataLayer = {};
    if (url === 'WELCOMEMODAL') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/welcomemodal.html';
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS['FRIENDLY_NAME_' + url];
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_WELCOME;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = ANALYTICS_CONSTANTS.BC_LANGUAGE_EN;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION] = 'Welcome';

    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
      if (ENV_PORTAL === 'fnabc') {
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
      }
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
  requestSupportContent(id, pageName) {
    return this.httpClientService.get(id + pageName, this.get_headers())
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

}
